import { TitleCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { UploadService } from 'src/app/services/core/documents/upload.service';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { companyVerificationLabels } from 'src/app/utils/common.utils';
import { addressValidator } from 'src/app/utils/custom-validators';
import { imageProcessing, ImageSnippet } from 'src/app/utils/image-processing-utils';
import { sweetAlert } from 'src/app/utils/swal';
import { onTimeChange, uploadDocumentImages,getFileNameFromUrl, phoneNumberLengthValidator, allowOnlyNumbersValidator} from 'src/app/utils/utils.common';
@UntilDestroy()
@Component({
  selector: 'app-add-credential-company',
  templateUrl: './add-credential-company.component.html',
  styleUrls: ['./add-credential-company.component.css']
})
export class AddCredentialCompanyComponent {
  companyForm!: FormGroup
  submitted = false;
  companyId: any;
  serviceAreas:any= [];
  selectedServiceArea:any
  profileImageURL: string | null = null;
  selectedFile: ImageSnippet | null = null;
  allTimezones = moment.tz.names();
  verification:any = false;
  rejectionReasons: any = {};
  user:any;
  days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ];

  constructor(private fb: FormBuilder,
    private credentialService: CredentialService,
    private router: Router,
    private uploadService: UploadService,
    private activatedRoute: ActivatedRoute,
    private sharedDataService: SharedDataService,
    private serviceArea: ServiceAreasService
  ) { }

  ngOnInit(): void {

    this.companyForm = this.fb.group({
      name: ['', Validators.required],
      phoneNumber: ['', [Validators.required, phoneNumberLengthValidator]],
      secondaryPhoneNumber: ['', [phoneNumberLengthValidator]],
      hoursofOperation: this.fb.array([]),
      email: ['', [Validators.required, Validators.email]],
      timeZone: ['', Validators.required],
      profileImageURL: ['', Validators.required],
      webURL: [''],
      signup: [''],
      serviceAreas: [[], Validators.required],
      address: this.fb.group({
        name: ['', Validators.required],
        coords: [[]],
        city: ['', Validators.required],
        state: ['', Validators.required],
      }, { validators: addressValidator() }),

      owner: this.fb.group({
        firstName: ['', Validators.required],
        middleName: [''],
        lastName: ['', Validators.required],
        phoneNumber: ['', [Validators.required, phoneNumberLengthValidator]],
        email: ['', [Validators.required, Validators.email]],
        driverLicenseImage: [''],

        address: this.fb.group({
          name: ['', Validators.required],
          coords: [[]],
          city: ['', Validators.required],
          state: ['', Validators.required],
        }, { validators: addressValidator() })
      },{validators: allowOnlyNumbersValidator('phoneNumber')}),

      documents: this.fb.group({
        hIPAATrainingCertificateImage: [''],
        hIPAATrainingDate: [''],
        hIPAATrainingExpireDate: [''],
        fraudWasteAndAbuseCertificateImage: [''],
        fraudWasteAndAbuseCertificateDate: [''],
        fraudWasteAndAbuseCertificateExpireDate: [''],
        nonDisclosureAgreementImage: [''],
        transportationProviderAgreementImage: [''],
        w9Image: [''],
        disclosureofOwnershipImage: [''],
        eFTFormImage: [''],
        voidedCheckImage: [''],
        driverScheduleImage: [''],
        vehicleScheduleImage: [''],
        vehicleForHireLicenseImage: [''],
      }),

      insurance: this.fb.group({
        generalLiabilityInsuranceImage: [''],
        generalLiabilityInsuranceDate: [''],
        generalLiabilityInsuranceExpireDate: [''],
        autoLiabilityInsuranceImage: [''],
        autoLiabilityInsuranceDate: [''],
        autoLiabilityInsuranceExpireDate: [''],
        workerCOIImage: [''],
        workerCOIImageExpireDate: [''],
      }),

      bankDetails: this.fb.group({
        name: [''],
        accountNumber: [''],
        routingNumber: [''],
      }),

      taxInformation: this.fb.group({
        name: [''],
        npi: [''],
        taxId: [''],
        taxonomy: [''],
      }),

      focalPersonInformation: this.fb.group({
        name: [''],
        email: [''],
        contactNumber: ['', [phoneNumberLengthValidator]],
        phoneNumber: ['', [phoneNumberLengthValidator]],
      }),

    }, {
      validators: [
        allowOnlyNumbersValidator('phoneNumber'),
        allowOnlyNumbersValidator('secondaryPhoneNumber'),
      ]
    });
    this.getUser();
    this.getServiceAreaPicker()
    this.getCompanybyId();
    this.validateLinkedDates(this.document, 'hIPAATrainingDate', 'hIPAATrainingExpireDate');
    this.validateLinkedDates(this.document, 'fraudWasteAndAbuseCertificateDate', 'fraudWasteAndAbuseCertificateExpireDate');
    this.validateLinkedDates(this.insurance, 'generalLiabilityInsuranceDate', 'generalLiabilityInsuranceExpireDate');
    this.validateLinkedDates(this.insurance, 'autoLiabilityInsuranceDate', 'autoLiabilityInsuranceExpireDate');
    if (!this.companyId) {
      this.loadOperationHours();
    }
  }


  getUser() {
    this.sharedDataService
    .getUser()
    .pipe(untilDestroyed(this))
    .subscribe(user => {
      if (user) {
        this.user = user;
        this.companyId = this.user.company.id
      }
    });
  }

  loadOperationHours(operationHours?: any) {
    const items = this.companyForm.get('hoursofOperation') as FormArray;
    if (operationHours && operationHours.length) {
      for (const day of operationHours) {
        items.push(
          this.fb.group({
            enabled: [{value: day.enabled, disabled: this.verification.isHoursofOperation}],
            startTime: [moment(day.startTime, "HH:mm").toISOString()],
            endTime: [moment(day.endTime, "HH:mm").toISOString()],
          })
        );
      }
    } else {
      for (let i = 0; i < this.days.length; i++) {
        items.push(
          this.fb.group({
            enabled: [{value:false, disabled: this.verification.isHoursofOperation}],
            startTime: [moment().startOf('day').toISOString()],
            endTime: [moment().endOf('day').toISOString()],
          })
        );
      }
    }
  }

  onSave() {
    this.submitted = true;
    if (this.companyForm.invalid) {
      return;
    }
    const payload = this.companyForm.value
    payload.hoursofOperation = this.companyForm.get('hoursofOperation')?.getRawValue();
    payload.hoursofOperation.forEach((day: any) => {
      day.startTime = moment(day.startTime).format('HH:mm');
      day.endTime = moment(day.endTime).format('HH:mm');
    });

     if (payload.documents) {
      payload.documents.hIPAATrainingDate = payload.documents.hIPAATrainingDate
        ? moment(payload.documents.hIPAATrainingDate).format('YYYY-MM-DD')
        : null;
      payload.documents.hIPAATrainingExpireDate = payload.documents.hIPAATrainingExpireDate
        ? moment(payload.documents.hIPAATrainingExpireDate).format('YYYY-MM-DD')
        : null;
      payload.documents.fraudWasteAndAbuseCertificateDate = payload.documents.fraudWasteAndAbuseCertificateDate
        ? moment(payload.documents.fraudWasteAndAbuseCertificateDate).format('YYYY-MM-DD')
        : null;
      payload.documents.fraudWasteAndAbuseCertificateExpireDate = payload.documents.fraudWasteAndAbuseCertificateExpireDate
        ? moment(payload.documents.fraudWasteAndAbuseCertificateExpireDate).format('YYYY-MM-DD')
        : null;
    }

    if (payload.insurance) {
      payload.insurance.generalLiabilityInsuranceDate = payload.insurance.generalLiabilityInsuranceDate
        ? moment(payload.insurance.generalLiabilityInsuranceDate).format('YYYY-MM-DD')
        : null;
      payload.insurance.generalLiabilityInsuranceExpireDate = payload.insurance.generalLiabilityInsuranceExpireDate
        ? moment(payload.insurance.generalLiabilityInsuranceExpireDate).format('YYYY-MM-DD')
        : null;
      payload.insurance.autoLiabilityInsuranceDate = payload.insurance.autoLiabilityInsuranceDate
        ? moment(payload.insurance.autoLiabilityInsuranceDate).format('YYYY-MM-DD')
        : null;
      payload.insurance.autoLiabilityInsuranceExpireDate = payload.insurance.autoLiabilityInsuranceExpireDate
        ? moment(payload.insurance.autoLiabilityInsuranceExpireDate).format('YYYY-MM-DD')
        : null;
      payload.insurance.workerCOIImageExpireDate = payload.insurance.workerCOIImageExpireDate
        ? moment(payload.insurance.workerCOIImageExpireDate).format('YYYY-MM-DD')
        : null;
    }
    if (this.companyId) {
      sweetAlert(
        'Confirm Update',
        'Do you want to update and request review, or just update?',
        'question',
        'Update & Request Review',
        'Update'
      ).then((result: any) => {
        if (result.isConfirmed) {
          this.saveCompany(payload, true);
        } else if (result.isDismissed && result.dismiss === 'cancel') {
          this.saveCompany(payload, false);
        }
      });
    } else {
      this.saveCompany(payload, false);
    }
  }

  private saveCompany(payload: any, alsoRequestReview: boolean) {
    this.credentialService.saveComanies(this.companyId, payload).subscribe(async (data: any) => {
      if (data) {
        if (alsoRequestReview) {
          await this.sendInvalidFields();
        }
        this.router.navigateByUrl('/dashboard')
      }
    },
       (err) => {
       sweetAlert("Error", err, "error", "Ok");
    }
    )
  }


  getCompanybyId() {
    this.credentialService.getCompanyById(this.companyId).pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data) {
          this.companyForm.patchValue({
            ...data,
            documents: {
              ...data.documents,
              hIPAATrainingDate: data.documents?.hIPAATrainingDate
                ? moment.parseZone(data.documents.hIPAATrainingDate).format('YYYY-MM-DD')
                : null,
              hIPAATrainingExpireDate: data.documents?.hIPAATrainingExpireDate
                ? moment.parseZone(data.documents.hIPAATrainingExpireDate).format('YYYY-MM-DD')
                : null,
              fraudWasteAndAbuseCertificateDate: data.documents?.fraudWasteAndAbuseCertificateDate
                ? moment.parseZone(data.documents.fraudWasteAndAbuseCertificateDate).format('YYYY-MM-DD')
                : null,
              fraudWasteAndAbuseCertificateExpireDate: data.documents?.fraudWasteAndAbuseCertificateExpireDate
                ? moment.parseZone(data.documents.fraudWasteAndAbuseCertificateExpireDate).format('YYYY-MM-DD')
                : null,
            },
            insurance: {
              ...data.insurance,
              generalLiabilityInsuranceDate: data.insurance?.generalLiabilityInsuranceDate
                ? moment.parseZone(data.insurance.generalLiabilityInsuranceDate).format('YYYY-MM-DD')
                : null,
              generalLiabilityInsuranceExpireDate: data.insurance?.generalLiabilityInsuranceExpireDate
                ? moment.parseZone(data.insurance.generalLiabilityInsuranceExpireDate).format('YYYY-MM-DD')
                : null,
              autoLiabilityInsuranceDate: data.insurance?.autoLiabilityInsuranceDate
                ? moment.parseZone(data.insurance.autoLiabilityInsuranceDate).format('YYYY-MM-DD')
                : null,
              autoLiabilityInsuranceExpireDate: data.insurance?.autoLiabilityInsuranceExpireDate
                ? moment.parseZone(data.insurance.autoLiabilityInsuranceExpireDate).format('YYYY-MM-DD')
                : null,
              workerCOIImageExpireDate: data.insurance?.workerCOIImageExpireDate
                ? moment.parseZone(data.insurance.workerCOIImageExpireDate).format('YYYY-MM-DD')
                : null,
            }
          });

          if (data.validationFlags) {
            this.verification = data.validationFlags;
          }
          this.rejectionReasons = data.rejectionReasons || {};
          if (data.hoursofOperation && data.hoursofOperation.length) {
            this.loadOperationHours(data.hoursofOperation);
          } else {
            this.loadOperationHours();
          }
          this.profileImageURL = data.profileImageURL
          this.selectedServiceArea = data.serviceAreas
        }
      })
  }

  getServiceAreaPicker() {
    this.serviceArea.getPicker({ isActive: true, limit:9999 }).pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results ) {
        this.serviceAreas = data.results.map((area: any) => ({
          ...area,
          title: new TitleCasePipe().transform(area.title)
        }));
      }
    });
  }

  processFile(imageInput: any) {
    imageProcessing(imageInput).subscribe({
      next: (result) => {
        this.selectedFile = result.file;
        if (!this.selectedFile || !(this.selectedFile instanceof Blob)) {
          return;
        }
        this.uploadService.uploadImageToServer(this.selectedFile).subscribe({
          next: (uploadResult: any) => {
            if (uploadResult?.fileUrl) {
              this.companyForm.get('profileImageURL')?.setValue(uploadResult.fileUrl);
              this.profileImageURL = uploadResult.fileUrl;
            }
          },
        });
      },
      error: (processingError) => {
        console.error('Error processing image:', processingError);
      },
    });
  }

  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName)
  }
   
  getFileName(url: any) {
    return getFileNameFromUrl(url);
  }

  getRejectionReason(section: string, controlName: string): string {
    return this.rejectionReasons?.[section]?.[controlName]?.reason || '';
  }

  uploadDocumentImages(documents: any, formControl: AbstractControl<any, any> | null) {
    uploadDocumentImages(documents, formControl, this.uploadService)
  }

  onSelectAddress(place: any): void {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.long_name : '';
    this.companyForm.patchValue({
      address: {
        city: cityName,
        state: stateName,
        name: place.formatted_address,
        coords: [
          place.geometry.location.lng(),
          place.geometry.location.lat()
        ]
      }
    });
  }

  onSelectOwnerAddress(place: any): void {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.long_name : '';
    this.ownerForm.patchValue({
      address: {
        city: cityName,
        state: stateName,
        name: place.formatted_address,
        coords: [
          place.geometry.location.lng(),
          place.geometry.location.lat()
        ]
      }
    });
  }

  deleteFile(formControl: AbstractControl<any, any> | null, fileInput: HTMLInputElement) {
    formControl?.setValue(null); // Safely calls setValue if formControl is not null
    if (fileInput) {
      fileInput.value = '';
    }
  }

    getInvalidFields(): string[] {
      const formValues = this.verification;
      const labels: string[] = [];
      this.traverseForm(formValues, companyVerificationLabels, labels);
      return labels;
    }
  
    traverseForm(values: any, labelMap: any, labels: string[], prefix: string = ''): void {
      Object.keys(values).forEach(key => {
        if (typeof values[key] === 'object' && values[key] !== null) {
          // Check if labelMap[key] is an object, recursively call the function
          if (typeof labelMap[key] === 'object') {
            this.traverseForm(values[key], labelMap[key], labels, prefix);
          } else {
            this.traverseForm(values[key], labelMap[key], labels, prefix + labelMap[key] + ' - ');
          }
        } else if (values[key] === false) {
          labels.push(prefix + (labelMap[key] || key));
        }
      });
    }
  
    async sendInvalidFields(): Promise<void> {
      const invalidFields = this.getInvalidFields();
      console.log("Invalid Fields: ", invalidFields);

      if (invalidFields.length > 0) {
        try {
          const data = await this.credentialService.requestReviewCompany(this.companyId, invalidFields).toPromise();
          if (data) {
            console.log("Review request sent successfully.");
            // this.onCloseModal();
          }
        } catch (err) {
          sweetAlert("Error", err, "error", "Ok");
        }
      }
    }

  validateLinkedDates(formGroup: FormGroup, startCtrl: string, endCtrl: string) {
    formGroup.valueChanges.subscribe(values => {
      const start = values[startCtrl];
      const end = values[endCtrl];

      const startControl = formGroup.get(startCtrl);
      const endControl = formGroup.get(endCtrl);

      if (start && end && new Date(start) >= new Date(end)) {
        endControl?.setErrors({ dateMismatch: true });
      } else {
        if (endControl?.hasError('dateMismatch')) {
          endControl.setErrors(null);
        }
      }
    });
  }


    onSelectServiceAreas(){
      this.companyForm.patchValue({
        serviceAreas: this.selectedServiceArea
      });
   }


  get form() {
    return this.companyForm.controls;
  }

  get address() {
    return this.companyForm.controls.address as FormGroup;
  }

  get ownerForm() {
    return this.companyForm.controls.owner as FormGroup;
  }

  get focalPersonForm() {
    return this.companyForm.controls.focalPersonInformation as FormGroup;
  }

  get document() {
    return this.companyForm.controls.documents as FormGroup;
  }

  get insurance() {
    return this.companyForm.controls.insurance as FormGroup;
  }

  get bankDetail() {
    return this.companyForm.controls.bankDetails as FormGroup;
  }

  get operationsArray() {
    return this.companyForm.get('hoursofOperation') as FormArray;
  }

   onChangeOriginAddress() {
    this.companyForm.patchValue({
      address: {
          coords: '',
          city: '',
          state: '',
          zipCode: '',
        }
    });
  }
  onChangeOwnerOriginAddress() {
    this.companyForm.patchValue({
      owner:{
         address: {
          coords: '',
          city: '',
          state: '',
          zipCode: '',
        }
      }
    });
  }

  hoursCheckboxChange(index: number) {
    const day = this.operationsArray.at(index);
    const enabled = day.get('enabled')?.value;
    const startCtrl = day.get('startTime');
    const endCtrl = day.get('endTime');

    if (enabled) {
      startCtrl?.setValidators(Validators.required);
      endCtrl?.setValidators(Validators.required);
      startCtrl?.updateValueAndValidity();
      endCtrl?.updateValueAndValidity();
    } else {
      startCtrl?.clearValidators();
      endCtrl?.clearValidators();
      startCtrl?.updateValueAndValidity();
      endCtrl?.updateValueAndValidity();
    }
  }

}
